
export const modules = [
  { 
    id: '1', 
    moduleName: 'Digital Literacy Fundamentals', 
    startDate: '2025-07-14', 
    endDate: '2025-07-18',
    description: 'Essential computer skills, internet navigation, and digital communication for modern workplace success',
    difficulty: 'Beginner',
    estimatedHours: 35,
    prerequisites: [],
    learningObjectives: [
      'Master basic computer operations and file management',
      'Navigate the internet safely and efficiently',
      'Use email and digital communication tools professionally',
      'Understand digital security and privacy best practices'
    ],
    lessons: [
      {
        id: '1-1',
        title: 'Computer Basics & Setup',
        duration: '2 hours',
        type: 'video',
        content: 'Learn about computer hardware, operating systems, and basic setup procedures',
        completed: false
      },
      {
        id: '1-2',
        title: 'File Management & Organization',
        duration: '3 hours',
        type: 'video',
        content: 'Master file systems, folder structures, and digital organization techniques',
        completed: false
      },
      {
        id: '1-3',
        title: 'Internet Navigation & Safety',
        duration: '4 hours',
        type: 'video',
        content: 'Safe browsing practices, search techniques, and evaluating online information',
        completed: false
      },
      {
        id: '1-4',
        title: 'Email & Digital Communication',
        duration: '3 hours',
        type: 'video',
        content: 'Professional email etiquette, digital communication tools, and collaboration platforms',
        completed: false
      },
      {
        id: '1-5',
        title: 'Project: Digital Portfolio Setup',
        duration: '8 hours',
        type: 'project',
        content: 'Create a professional digital portfolio showcasing your skills and achievements',
        completed: false
      }
    ]
  },
  { 
    id: '2', 
    moduleName: 'Professional Skills Development', 
    startDate: '2025-07-21', 
    endDate: '2025-07-25',
    description: 'Develop essential workplace skills including communication, teamwork, and professional etiquette',
    difficulty: 'Intermediate',
    estimatedHours: 32,
    prerequisites: ['1'],
    learningObjectives: [
      'Master professional communication in workplace settings',
      'Develop effective teamwork and collaboration skills',
      'Learn time management and productivity techniques',
      'Build leadership and problem-solving capabilities'
    ],
    lessons: [
      {
        id: '2-1',
        title: 'Professional Communication Skills',
        duration: '3 hours',
        type: 'video',
        content: 'Master verbal and written communication in professional environments',
        completed: false
      },
      {
        id: '2-2',
        title: 'Teamwork & Collaboration',
        duration: '4 hours',
        type: 'video',
        content: 'Effective team dynamics, conflict resolution, and collaborative problem-solving',
        completed: false
      },
      {
        id: '2-3',
        title: 'Time Management & Productivity',
        duration: '3 hours',
        type: 'video',
        content: 'Planning techniques, prioritization, and productivity tools for workplace success',
        completed: false
      },
      {
        id: '2-4',
        title: 'Leadership & Problem-Solving',
        duration: '3 hours',
        type: 'video',
        content: 'Develop leadership mindset and analytical problem-solving approaches',
        completed: false
      },
      {
        id: '2-5',
        title: 'Project: Workplace Scenario Simulation',
        duration: '10 hours',
        type: 'project',
        content: 'Apply professional skills in realistic workplace scenarios and case studies',
        completed: false
      }
    ]
  },
  { 
    id: '3', 
    moduleName: 'Industry-Specific Skills & Certification', 
    startDate: '2025-07-28', 
    endDate: '2025-08-01',
    description: 'Specialized training for specific industries with internationally recognized certification preparation',
    difficulty: 'Advanced',
    estimatedHours: 28,
    prerequisites: ['2'],
    learningObjectives: [
      'Master industry-specific software and tools',
      'Understand regulatory compliance and standards',
      'Develop specialized technical competencies',
      'Prepare for professional certification exams'
    ],
    lessons: [
      {
        id: '3-1',
        title: 'Industry Software Mastery',
        duration: '3 hours',
        type: 'video',
        content: 'Master specialized software and tools specific to your chosen industry',
        completed: false
      },
      {
        id: '3-2',
        title: 'Regulatory Compliance & Standards',
        duration: '4 hours',
        type: 'video',
        content: 'Understand industry regulations, quality standards, and compliance requirements',
        completed: false
      },
      {
        id: '3-3',
        title: 'Technical Competency Development',
        duration: '3 hours',
        type: 'video',
        content: 'Advanced technical skills and best practices for professional excellence',
        completed: false
      },
      {
        id: '3-4',
        title: 'Certification Exam Preparation',
        duration: '2 hours',
        type: 'video',
        content: 'Comprehensive preparation for industry-recognized certification exams',
        completed: false
      },
      {
        id: '3-5',
        title: 'Capstone Project: Industry Portfolio',
        duration: '12 hours',
        type: 'project',
        content: 'Create a comprehensive portfolio demonstrating industry-ready skills and knowledge',
        completed: false
      }
    ]
  }
];
